import { useState } from "react";
import { Link } from "react-router-dom";
import { Sun, X } from "lucide-react";

export default function TopBanner() {
  const [open, setOpen] = useState(() => sessionStorage.getItem("rv_banner_dismissed") !== "1");
  if (!open) return null;
  return (
    <div
      data-testid="top-banner"
      className="relative z-[60] bg-brand-red text-white"
    >
      <div className="container-rv flex items-center justify-center gap-3 py-2.5 text-center text-xs sm:text-sm">
        <Sun className="hidden h-4 w-4 shrink-0 sm:block" />
        <Link
          to="/book?promo=SUMMER10"
          data-testid="banner-book-link"
          className="font-medium tracking-wide hover:underline underline-offset-4"
        >
          Summer Special: <span className="font-semibold">Members get 10% off All Details</span>
        </Link>
        <button
          data-testid="banner-dismiss-button"
          aria-label="Dismiss banner"
          onClick={() => { setOpen(false); sessionStorage.setItem("rv_banner_dismissed", "1"); }}
          className="absolute right-4 top-1/2 -translate-y-1/2 rounded-full p-1 transition-colors hover:bg-white/20"
        >
          <X className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
}
